import React, { useState } from 'react';

export function ShareStatus() {
  const [shareData,] = useState([]);

  return (
    <>
      <div className="">
        <h1 className="text-2xl font-bold mb-6">Share Status Report</h1>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-gray-500 text-sm">Total Shares</h3>
            <p className="text-2xl font-bold">245</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-gray-500 text-sm">Available Shares</h3>
            <p className="text-2xl font-bold text-green-600">156</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-gray-500 text-sm">Booked Shares</h3>
            <p className="text-2xl font-bold text-blue-600">89</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-gray-500 text-sm">Completed</h3>
            <p className="text-2xl font-bold text-purple-600">45</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Share Details</h2>
            <div className="flex space-x-2">
              <select className="border rounded p-2">
                <option value="">All Animals</option>
                <option value="cow">Cow</option>
                <option value="goat">Goat</option>
                <option value="camel">Camel</option>
              </select>
              <input type="date" className="border rounded p-2" />
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Animal ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total Shares</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Booked</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Available</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {shareData.map((item, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4">{item.animalId}</td>
                    <td className="px-6 py-4">{item.type}</td>
                    <td className="px-6 py-4">{item.totalShares}</td>
                    <td className="px-6 py-4">{item.bookedShares}</td>
                    <td className="px-6 py-4">{item.availableShares}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 rounded-full text-xs ${item.status === 'completed' ? 'bg-green-100 text-green-800' :
                        item.status === 'partial' ? 'bg-yellow-100 text-yellow-800' :
                          'bg-blue-100 text-blue-800'
                        }`}>
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}